(function(){
const copy = JSON.parse(document.getElementById('fp-seniors-video-copy').textContent);
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
const userPaused = new WeakSet();
const videos = [...document.querySelectorAll('video')];
function update(video) {
  const button = video.closest('.media').querySelector('.v-toggle');
  button.textContent = video.paused ? copy.play : copy.pause;
  button.setAttribute('aria-label', video.paused ? copy.playLabel : copy.pauseLabel);
}
const observer = new IntersectionObserver(entries => {
  entries.forEach(({ target: video, isIntersecting }) => {
    if (isIntersecting && !reduced && !userPaused.has(video)) {
      video.play().catch(() => update(video));
    } else if (!isIntersecting) video.pause();
    update(video);
  });
}, { threshold: .25 });
videos.forEach(video => {
  video.muted = true;
  if (reduced) { video.autoplay = false; video.removeAttribute('autoplay'); video.pause(); }
  video.addEventListener('play', () => update(video));
  video.addEventListener('pause', () => update(video));
  video.addEventListener('error', () => video.closest('.media').classList.add('is-error'));
  video.closest('.media').querySelector('.v-toggle').addEventListener('click', () => {
    if (video.paused) { userPaused.delete(video); video.play().catch(() => {}); }
    else { userPaused.add(video); video.pause(); }
    update(video);
  });
  observer.observe(video);
});
document.addEventListener('visibilitychange', () => {
  if (document.hidden) videos.forEach(video => video.pause());
});
function updateSticky() {
  const start = document.querySelector('.shop-start');
  document.querySelector('.sticky').classList.toggle('show', start.getBoundingClientRect().top < 0);
}
window.addEventListener('scroll', updateSticky, { passive: true });
window.addEventListener('resize', updateSticky);
updateSticky();

})();
